/* SoLifeIN - guaranteed sticky header.
   CSS position:sticky silently fails if ANY ancestor has an overflow value
   other than visible. Rather than hunt for that ancestor, detach the header
   to position:fixed on scroll and hold its place with a spacer. */
(function () {
  // A section inside a section group gets a group-prefixed id, e.g.
  // shopify-section-sections--27085101531452__sl_header. Looking up the bare
  // id returned null on the live site, so this whole fallback never ran.
  // Resolve from the rendered bar instead, which is always present.
  function findHeader() {
    var bar = document.querySelector('.slhd');
    var sec = bar && bar.closest('[id^="shopify-section"], .sl-header-section');
    return sec ||
      document.querySelector('.sl-header-section') ||
      document.querySelector('[id^="shopify-section"][id$="__sl_header"]') ||
      document.getElementById('shopify-section-sl_header');
  }

  function init() {
    var sec = findHeader();
    if (!sec) return;

    // spacer preserves layout height once the header is detached
    var spacer = document.createElement('div');
    spacer.className = 'sl-header-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.display = 'none';
    sec.parentNode.insertBefore(spacer, sec.nextSibling);

    var pinned = false;

    function measure() {
      return sec.getBoundingClientRect().height;
    }

    function anchorTop() {
      // distance from top of document to the header's resting position
      var y = 0, el = pinned ? spacer : sec;
      while (el) { y += el.offsetTop; el = el.offsetParent; }
      return y;
    }

    var restingTop = anchorTop();

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (!pinned && y > restingTop) {
        var h = measure();
        spacer.style.height = h + 'px';
        spacer.style.display = 'block';
        sec.classList.add('sl-pinned');
        pinned = true;
      } else if (pinned && y <= restingTop) {
        sec.classList.remove('sl-pinned');
        spacer.style.display = 'none';
        pinned = false;
      }
    }

    function onResize() {
      if (pinned) {
        sec.classList.remove('sl-pinned');
        spacer.style.display = 'none';
        pinned = false;
      }
      restingTop = anchorTop();
      onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
